import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import SocialNetworks from "./SocialNetworks";

export default class Intro extends Component {
    render() {
        return (
            <section className="hero-min-fullscreen bg-lines flex-center py-8 px-5">
                <div className="container p-0">
                    <div className="row no-gutters flex-center">

                        <div className="col-md-6 align-self-start" data-animation="fade-in-left 1s .2s">
                            <img src="img/cutiko_profile.jpg" className="radius-1 shadow-1"
                                 alt="cutiko foto de perfil"/>
                        </div>

                        <div className="col-md-6 px-0 px-md-5 px-lg-7" data-animation="fade-in-left 1s .4s">
                            <p className="small bold mb-5">Soy Cutiko</p>
                            <h2 className="bold">Desarrollador Android, React y Firebase</h2>
                            <hr className="separator-left"/>
                            <p>Soy serverless porque así me ocupo de trabajar en donde realmente está el valor</p>

                            <p className="small serif text-links mt-5">
                                <SocialNetworks/>
                            </p>

                            <Link to="/contact" className="button style-6 mt-6">Escríbeme</Link>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/visitors/components/Intro.js